// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"Ay","cross":"Az","iconSVGWrapper":"AA","iconSVG":"AB","iconSVGDark":"AC"};